export default __webpack_public_path__ + "static/media/3.36a92984.svg";